import React from 'react'
import TenantEdit from './TenantEdit'

const EditTenant = () => {
    return (
        <TenantEdit />
    )
}

export default EditTenant